import { env } from "."

const RUNTIME_ENV_PLACEHOLDER_PATTERN = /^RUNTIME_ENV_START_[A-Z_]+_RUNTIME_ENV_END$/

function normalizeAccessToken(value: string | undefined): string | undefined {
  const token = value?.trim()

  if (!token || RUNTIME_ENV_PLACEHOLDER_PATTERN.test(token)) {
    return undefined
  }

  return token
}

export function getStoryblokClientAccessToken(): string | undefined {
  return normalizeAccessToken(env("NEXT_PUBLIC_STORYBLOK_API_KEY"))
}

export function getStoryblokServerAccessToken(): string | undefined {
  return (
    normalizeAccessToken(env("STORYBLOK_API_KEY")) ||
    normalizeAccessToken(process.env.NEXT_PUBLIC_STORYBLOK_API_KEY)
  )
}

export function getStoryblokRuntimeAccessToken(): string | undefined {
  if (typeof window === "undefined") {
    return getStoryblokServerAccessToken()
  }

  return getStoryblokClientAccessToken()
}
